import * as swaggerApi from '../../swagger/src/index'
import config from '../config/index'

/**
 * @package swaggerApi
 * @type {{install(*): void}}
 */
let Swagger = {
    install(Vue){
        swaggerApi.ApiClient.instance.basePath = config.baseURL;
        Object.defineProperty(Vue.prototype, '$swagger', {value: swaggerApi})
        Object.defineProperty(Vue.prototype, '$userControllerApi',
                    {value: new swaggerApi.UsercontrollerApi()})
        Object.defineProperty(Vue.prototype, '$ergoRiskMatrixControllerApi',
                    {value: new swaggerApi.ErgoriskmatrixcontrollerApi()})
    }
};
export default Swagger;
